import React from "react";
import moment from "moment";
import { useTranslation } from "react-i18next";
import { SeatTicketInfoConfirmStyled } from "./styled";
import { Buttons } from "components";

// ยืนยันก่อนให้เข้างาน (เจ้าหน้าที่สแกนตั๋วที่นั่ง) แสดงข้อมูลจาก verify ของ API
const SeatTicketInfoConfirm = ({ info, onCancel, onConfirm }) => {
  const { t, i18n } = useTranslation(["seat"]);
  const rows = [
    [t("Activity name", { ns: "seat" }), i18n.language === "en" ? info.activity_name_en : info.activity_name_th],
    [t("Booking code", { ns: "seat" }), info.code],
    [t("Seat", { ns: "seat" }), info.seat_id],
    [t("Audience name", { ns: "seat" }), info.viewer_name || "-"],
    [t("Booker", { ns: "seat" }), info.booker_name || "-"],
    // GEN/GUEST เป็นรหัสระบบ (ไม่ระบุโรงเรียน / ภายใน-VIP) ไม่ใช่ชื่อโรงเรียน
    [
      t("Music school", { ns: "seat" }),
      info.school_code === "GEN"
        ? t("Not specified", { ns: "seat" })
        : !info.school_code || info.school_code === "GUEST"
        ? "-"
        : `${info.school_code} · ${info.school_name || ""}`,
    ],
  ];
  return (
    <SeatTicketInfoConfirmStyled>
      <div className="stc_title">{t("Confirm entry", { ns: "seat" })}</div>
      {rows.map(([label, value]) => (
        <div className="stc_row" key={label}>
          <div className="stc_label">{label}</div>
          <div className="stc_value">{value}</div>
        </div>
      ))}
      {!info.can_enter && (
        <div className="stc_used">
          {t("This ticket was already used at {{time}} by {{admin}}", {
            ns: "seat",
            time: moment(info.used_at).format("DD/MM/YYYY HH:mm"),
            admin: info.used_by_admin_name || "-",
          })}
        </div>
      )}
      <div className="stc_btns">
        <div>
          <Buttons.BgStandard theme_white_purple label={t("Close", { ns: "seat" })} onClick={onCancel} />
        </div>
        {info.can_enter && (
          <div>
            <Buttons.BgStandard label={t("Confirm entry", { ns: "seat" })} onClick={onConfirm} />
          </div>
        )}
      </div>
    </SeatTicketInfoConfirmStyled>
  );
};

export default SeatTicketInfoConfirm;
